import React from "react";
import { useTranslation } from "react-i18next";

export default function Spe(): JSX.Element {
    const { t } = useTranslation("assessment");
    return (
        <>
            <h3>{t("spe.title") as string}</h3>
            <p>{t("spe.list-title") as string}</p>
            <ul>
                <li>{t("spe.list.point-1") as string}</li>
                <li>{t("spe.list.point-2") as string}<em>{t("spe.list.point-2-bolded") as string}</em></li>
            </ul>
            <p>{t("spe.paragraph-1") as string}</p>
            <p>{t("spe.paragraph-2") as string}<a className="bolder-text" href={t("spe.hyperlink") as string} target='_blank' rel="noopener noreferrer">{t("spe.hyperlink-text") as string}</a></p>
        </>
    );
}